import "./LogoGrid.css";
import logo from "../../../assets/yapa-logo.png";
const LogoGrid = () => {
  const logoOnClick = () => {
    console.log("Logo clicked");
  };

  return (
    <div className="logo-grid">
      <img src={logo} alt="Logo YAPA" onClick={logoOnClick} />
    </div>
  );
};

export default LogoGrid;
